// src/utils/pdfTripSheet.js
import { jsPDF } from "jspdf";

export function generateTripSheetPdf(orderId, order, items, skuMaster, totals) {
  const pdf = new jsPDF("portrait", "mm", "a4");

  // LEFT SECTION LIMITS
  const leftX = 10;
  const maxWidth = 95; // left half width
  const rightX = leftX + maxWidth;

  let y = 15;

  // -----------------------------
  // CENTERED TITLE (within left half)
  // -----------------------------
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text("TRIP SHEET", leftX + maxWidth / 2, y, { align: "center" });

  y += 12;

  // -----------------------------
  // NAME + DATE
  // -----------------------------
  pdf.setFontSize(11);
  pdf.setFont("helvetica", "normal");

  pdf.text("Name :", leftX, y);
  pdf.text(order.partyName || "-", leftX + 25, y);

  pdf.text("Date :", leftX, y + 8);
  // Convert ISO date → DD/MM/YYYY
const finalDate = order.orderDateOnly
  ? new Date(order.orderDateOnly).toLocaleDateString("en-IN")
  : "-";

pdf.text(finalDate, leftX + 25, y+8);


  y += 20;

  // -----------------------------
  // TABLE HEADER (left half)
  // -----------------------------
  pdf.setFont("helvetica", "bold");
  pdf.rect(leftX, y - 5, maxWidth, 8);

  pdf.text("S.No", leftX + 2, y);
  pdf.text("Product Name", leftX + 18, y);
  pdf.text("Qty", leftX + maxWidth - 5, y, { align: "right" });

  y += 10;

  // -----------------------------
  // TABLE BODY (left half)
  // -----------------------------
  pdf.setFont("helvetica", "normal");

  let index = 1;

  Object.keys(items).forEach((sku) => {
    const qty = Number(items[sku] || 0);
    if (qty <= 0) return;

    const name = skuMaster[sku]?.Name || sku;

    // Row border
    pdf.rect(leftX, y - 5, maxWidth, 8);

    pdf.text(String(index), leftX + 2, y);
    pdf.text(name, leftX + 18, y);
    pdf.text(qty.toString(), leftX + maxWidth - 5, y, { align: "right" });

    y += 10;
    index++;
  });

  y += 5;

  // -----------------------------
  // TOTALS BOX (inside left half)
  // -----------------------------
  pdf.setFillColor(245, 245, 245);
  pdf.roundedRect(leftX, y, maxWidth, 18, 3, 3, "F");

  pdf.setFont("helvetica", "bold");
  pdf.text("Total Qty :", leftX + 3, y + 7);
  pdf.setFont("helvetica", "normal");
  pdf.text(String(totals.totalQty || 0), leftX + 35, y + 7);

  pdf.setFont("helvetica", "bold");
  pdf.text("Total Amount :", leftX + 3, y + 14);
  pdf.setFont("helvetica", "normal");
  pdf.text(String(totals.grandTotal?.toFixed(2) || "0.00"), leftX + 35, y + 14);

  y += 30;

  // -----------------------------
  // SIGNATURE LINE (left half)
  // -----------------------------
  pdf.setFont("helvetica", "bold");
  pdf.text("Received By:", leftX, y);
  pdf.line(leftX + 30, y + 1, leftX + 90, y + 1);

  return pdf;
}
